<template lang="pug">
  div
    h3 {{$t('groupPages.modules.links.title')}}
    .table-responsive
      table.table.table-hover.table-striped.audios
        tbody(v-sortable="{onUpdate: onListReorder, handle: '.drag-handle'}")
          tr.clickable(v-for='file in items', @click="showFile(file)")
            td(style="width: 30px")
              i.fa.fa-external-link
            td {{file.description}}
            td(v-if="openEditor")
              //- i.text-muted.fa.fa-arrows.drag-handle
              | &nbsp;&nbsp;&nbsp;
              i.text-danger.fa.fa-trash(@click="remove(file, $event)")
</template>
<script type="text/javascript">
import {hrS, hrT} from '@/components/shared/vue.globals'

import _ from 'lodash'
import api from '@/utils/api'

export default {
  props: ['vueData', 'module', 'openEditor'],
  filters: {
    hrS,
    hrT
  },
  computed: {
    items () {
      let items = []
      for (let link of this.module.items) {
        items.push({
          id: link.id,
          src: link.url,
          description: link.name || link.url
        })
      }
      return items
    }
  },
  methods: {
    showFile (item) {
      window.open(item.src, '_blank')
      window.focus()
    },
    askUpload () {
      this.$emit('askUpload')
    },
    onListReorder (event) {
      // this.module.items.splice(event.newIndex, 0, this.module.items.splice(event.oldIndex, 1)[0])
      // const oldItems = this.module.items
      // this.module.items = []
      // this.$nextTick(() => {
      //   this.module.items = oldItems
      //   console.log('new list', this.module.items)
      // })
    },
    remove (item, $event) {
      $event.stopPropagation()
      let index = _.findIndex(this.module.items, t => t.id === item.id)
      this.module.items.splice(index, 1)
      api.put('/node', {
        id: item.id,
        kind: 'file',
        public: false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// GroupPageLinks.vue?162c239b